<template>
  <el-dialog
    :title="title"
    :visible.sync="show"
    :width="width"
    :close-on-press-escape="showClose"
    :show-close="showClose"
    :close-on-click-modal="showClose"
    :append-to-body="appendToBody"
    :before-close="beforeClose"
  >
    <slot></slot>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="!showClose" @click="handleCancel">取 消</el-button>
      <el-button
        v-if="!showClose"
        type="primary"
        :loading="loading"
        @click="handleConfrim"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'BaseDialog',
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    // 重新打开是否销毁子元素
    destroyOnClose: {
      type: Boolean,
      default: true,
    },
    // 抽屉宽度
    width: {
      type: String,
      default: '30%',
    },
    // 是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: false,
    },
    // 弹框标题
    title: {
      type: String,
      default: '标题',
    },
    // Dialog 自身是否插入至 body 元素上
    appendToBody: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      show: false,
    };
  },
  watch: {
    visible: {
      handler() {
        this.show = this.visible;
        console.log(this.show)
      },
      immediate: true,
    },
  },
  created() {},
  methods: {
    // 点击取消
    handleCancel() {
      this.$emit('update:visible', false);
    },
    // 点击提交
    async handleConfrim() {
        this.loading = true;
        this.$emit('confirm', async (flag) => {
          this.loading = flag;
        });
    },

    beforeClose(done) {
      this.$emit('update:visible', false);
      done()
    },

    close() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-drawer__header) {
  color: #333;
  font-weight: bolder;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 0;
}
.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // border-bottom: 1px solid #eee;
  // padding-bottom: 10px;
  .header-left {
    font-size: 16px;
    font-weight: bolder;
    color: #333;
  }
}
.drawer-body {
  padding: 30px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
</style>
